import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Layout, { DocuLayout } from '../components/Layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DocuLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Orchestrator Messaging Events`}</h1>
    <h2>{`Text Formatting`}</h2>
    <p>{`Following event types support formatting:`}</p>
    <ul>
      <li parentName="ul">{`text message`}</li>
      <li parentName="ul">{`button template`}</li>
      <li parentName="ul">{`generic template (card title and subtitle)`}</li>
    </ul>
    <p>{`You can use this proprietary syntax to achieve different text formats:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Bold text`}</strong></p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`**example**`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><strong parentName="p">{`example`}</strong></p>
        </blockquote>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Italics text`}</strong></p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`__example__`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><em parentName="p">{`example`}</em></p>
        </blockquote>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Links`}</strong></p>
        <p parentName="li">{`  full links (with http/https schemes) are automatically converted to shortened form`}</p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`https://wingbot.ai/sasalele?some=query#with=hash`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "https://wingbot.ai/sasalele?some=query#with=hash"
            }}>{`wingbot.ai/sasalele`}</a></p>
        </blockquote>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Email links`}</strong></p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`sasalele@wingbot.ai`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "mailto:sasalele@wingbot.ai"
            }}>{`sasalele@wingbot.ai`}</a></p>
        </blockquote>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Phone numbers`}</strong></p>
        <p parentName="li">{`  with country prefix`}</p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`+420 602 123 456`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "tel:+420602123456"
            }}>{`+420 602 123 456`}</a></p>
        </blockquote>
        <p parentName="li">{`  with country prefix and some spacing characters`}</p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`+420 (0609) 112-777`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "tel:+4200609112777"
            }}>{`+420 (0609) 112-777`}</a></p>
        </blockquote>
        <p parentName="li">{`  numbers without country code should be prefixed with `}<inlineCode parentName="p">{`_tel:`}</inlineCode></p>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`_tel:12345`}</inlineCode></p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "tel:12345"
            }}>{`12345`}</a></p>
        </blockquote>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      